var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKycVerified(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11305_6120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 19.375C8.1458 19.375 6.33324 18.8252 4.79153 17.795C3.24982 16.7649 2.04821 15.3007 1.33863 13.5877C0.629062 11.8746 0.443406 9.9896 0.805142 8.17103C1.16688 6.35246 2.05976 4.68199 3.37088 3.37088C4.68199 2.05976 6.35246 1.16688 8.17103 0.805142C9.9896 0.443406 11.8746 0.629062 13.5877 1.33863C15.3007 2.04821 16.7649 3.24982 17.795 4.79153C18.8252 6.33324 19.375 8.1458 19.375 10C19.3722 12.4855 18.3836 14.8685 16.626 16.626C14.8685 18.3836 12.4855 19.3722 10 19.375ZM10 1.875C8.39303 1.875 6.82214 2.35153 5.486 3.24431C4.14985 4.1371 3.10844 5.40605 2.49348 6.8907C1.87852 8.37535 1.71762 10.009 2.03112 11.5851C2.34463 13.1612 3.11846 14.6089 4.25476 15.7452C5.39106 16.8815 6.8388 17.6554 8.41489 17.9689C9.99099 18.2824 11.6247 18.1215 13.1093 17.5065C14.594 16.8916 15.8629 15.8502 16.7557 14.514C17.6485 13.1779 18.125 11.607 18.125 10C18.1225 7.84588 17.2657 5.7807 15.7425 4.2575C14.2193 2.73431 12.1541 1.87749 10 1.875Z",
    fill: "url(#paint0_linear_11305_6120)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.74989 12.8125C8.66779 12.8127 8.58648 12.7966 8.51064 12.7651C8.4348 12.7337 8.36593 12.6876 8.30801 12.6294L6.43301 10.7544C6.31916 10.6365 6.25617 10.4786 6.25759 10.3148C6.25902 10.1509 6.32475 9.99413 6.44063 9.87825C6.55651 9.76237 6.71326 9.69664 6.87714 9.69521C7.04101 9.69379 7.19889 9.75679 7.31676 9.87064L9.19176 11.7456C9.27914 11.833 9.33865 11.9444 9.36275 12.0656C9.38686 12.1868 9.37448 12.3125 9.32719 12.4267C9.27989 12.5409 9.19981 12.6385 9.09705 12.7071C8.99429 12.7758 8.87348 12.8125 8.74989 12.8125Z",
    fill: "url(#paint1_linear_11305_6120)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75011 12.8125C8.62652 12.8125 8.50571 12.7758 8.40295 12.7071C8.30019 12.6385 8.22011 12.5409 8.17281 12.4267C8.12552 12.3125 8.11314 12.1868 8.13725 12.0656C8.16135 11.9444 8.22086 11.833 8.30824 11.7456L12.6832 7.37064C12.8011 7.25679 12.959 7.19379 13.1229 7.19521C13.2867 7.19664 13.4435 7.26237 13.5594 7.37825C13.6753 7.49413 13.741 7.65089 13.7424 7.81476C13.7438 7.97863 13.6808 8.13651 13.567 8.25438L9.19199 12.6294C9.13407 12.6876 9.0652 12.7337 8.98936 12.7651C8.91352 12.7966 8.83221 12.8127 8.75011 12.8125Z",
    fill: "url(#paint2_linear_11305_6120)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11305_6120",
    x1: 10,
    y1: 0.625,
    x2: 10,
    y2: 19.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026C3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#026C3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11305_6120",
    x1: 7.81616,
    y1: 9.69519,
    x2: 7.81616,
    y2: 12.8125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026C3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#026C3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11305_6120",
    x1: 10.9338,
    y1: 7.19519,
    x2: 10.9338,
    y2: 12.8125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026C3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#026C3D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11305_6120"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKycVerified);
export default __webpack_public_path__ + "static/media/KycVerified.30a56ae710b97da8fa71a9b774693d00.svg";
export { ForwardRef as ReactComponent };